export default {
  SENT: {
    KEY: 'SENT',
    COLOR: 'primary',
    TEXT: 'Wysłano'
  },
  PLANNED: {
    KEY: 'PLANNED',
    COLOR: 'success',
    TEXT: 'Zaplanowano'
  },
  ERROR: {
    KEY: 'ERROR',
    COLOR: 'danger',
    TEXT: 'Błąd'
  },
  READ: {
    KEY: 'READ',
    COLOR: 'warning',
    TEXT: 'Przeczytano'
  },
  MAILBOX_SETTINGS_NOT_FOUND: {
    KEY: 'MAILBOX_SETTINGS_NOT_FOUND',
    COLOR: 'danger',
    TEXT: 'Mail nie został wysłany z powodu braku konfiguracji skrzynki mailowej'
  },
};
